export enum AIBSourceApplication {
  WEB_ORDERING = 'webordering',
  GIFT_CARD = 'giftcard',
}
